import {
  faCamera,
  faFileUpload,
  faSpinner,
  faTimesCircle,
  faUndo
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import ModalFrame from "../../../../toolkit/modalFrame";
import CamMultiCapture from "../../common/CamMultiCaptureOBMobile";
import s from "./photoDocumentModal.scss";
import {
  errorOBNotification,
  successOBNotification
} from "../../../../OnBoardingUI/components/OBNotification/OBNotification.utils";

interface Props {
  isOpen: boolean;
  title: String;
  cancel: () => void;
  success: () => void;
  urlUpload?: string;
}

interface State {
  value: any;
  wait: boolean;
  cameraMode: boolean;
}

class PhotoDocumentModal extends React.Component<Props, State> {
  state = {
    value: null,
    wait: false,
    cameraMode: true
  };

  render() {
    return (
      <ModalFrame
        title={this.props.title}
        isOpen={this.props.isOpen}
        toggle={() => this.props.cancel()}
        size="sm"
      >
        <Container style={{ width: "90%" }} className="center-block p-0 mb-3">
          {this.props.urlUpload && !this.state.cameraMode && !this.state.wait && (
            <Row className="mt-4">
              <Col xs="12">
                <div className={s.cardCameraContainer}>
                  {/* Captura de foto */}
                  <div
                    className={`${s.cardCameraBtn}`}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ cameraMode: true });
                    }}
                  >
                    <div className={s.cardCameraBtnIcon}>
                      <FontAwesomeIcon icon={faCamera} />
                    </div>
                    <div className={s.cardCameraBtnText}>Capturar</div>
                  </div>

                  {/* Cancelar */}
                  <div
                    className={`${s.cardCameraBtn} ${s.cardCameraDanger}`}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();

                      if (this.state.wait) {
                        return false;
                      }
                      this.setState({ value: null });
                      this.props.cancel();
                    }}
                  >
                    <div className={s.cardCameraBtnIcon}>
                      <FontAwesomeIcon icon={faTimesCircle} />
                    </div>
                    <div className={s.cardCameraBtnText}>Cancelar</div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <Row className="mt-4">
            {this.props.urlUpload && !!this.state.cameraMode && (
              <Col xs="12" className="text-center">
                <CamMultiCapture
                  exportButtonTitle="Subir archivo"
                  exportFile={async (pdf: File) => {
                    const data = new FormData();
                    data.append("file", pdf);

                    this.setState({
                      wait: true,
                      cameraMode: true
                    });

                    try {
                      await axios.post(this.props.urlUpload, data, {
                        withCredentials: true
                      });
                      successOBNotification("Archivo cargado correctamente");
                      this.props.success();
                    } catch (error) {
                      errorOBNotification("No se pudo cargar el archivo");
                      this.props.cancel();
                    }
                    this.setState({
                      wait: false
                    });
                  }}
                />
              </Col>
            )}
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default withStyles(s)(PhotoDocumentModal);
